/* eslint-disable no-restricted-syntax */
/* eslint-disable no-loop-func */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-unreachable */
/**
 * #######################################################@
 *
 * Pages settings
 *
 * #######################################################@
 */
import "./style.css";

import {
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	MenuItem
} from "@mui/material";
import { useEffect, useState } from "react";
import MDButton from "components/Basics/MDButton";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import ProfileActions from "redux-react/actions/profileActions";
import SettingsActions from "redux-react/actions/settingsActions";
import i18n from "i18n";
import lod_ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { updatePermissions } from "redux-react/reducers/permissionsReducer";
import { display } from "redux-react/reducers/snackBarReducer";

const RolesBox = ({ name, code, rolesList = [], onChange }) => {
	const isInArray = arr => {
		return arr.includes(code);
	};

	return (
		<MenuItem onClick={() => onChange(code)}>
			<MDBox display="flex" alignItems="center" justifyContent="start">
				<Checkbox checked={isInArray(rolesList)} />
				<MDBox display="flex" flexDirection="column">
					<MDTypography variant="body">{name}</MDTypography>
					{/* <MDTypography variant="caption">({i18n.t(`SETTINGS.${type}`)})</MDTypography> */}
				</MDBox>
			</MDBox>
		</MenuItem>
	);
};

export default function PermissionsDialog({ open, onClose, page, refreshList }) {
	const profile = useSelector(state => state.profile);
	const dispatch = useDispatch();

	// -> Roles that will be displayed in the list to be selected
	const [defaultRolesList, setDefaultRolesList] = useState([]);
	// -> Roles that will be selected by the user
	const [rolesList, setRolesList] = useState([]);

	/**
	 * Close the dialog
	 */
	function close() {
		onClose();
	}
	/**
	 * Create the page permission
	 * format be like : "read:page_[type]_[name]"
	 * For dividers, need to create a random ID because they have no name
	 */
	function createPagePermission(page, list) {
		if (page.permissions && page.permissions.length > 0) {
			return page.permissions[0];
		}

		// If user didn't select any role, return null -> We dont want permission on this page
		if (!list || lod_.isEmpty(list)) return null;
		// If the page is a divider, create a random ID for it
		if (page.type === "divider") {
			let rdmID = Math.random().toString(36).substring(7);
			return `read:page_${page.type}_${rdmID}`;
		}
		// Else, return the permission
		return `read:page_${page.type}_${page.routeName}`;
	}

	/**
	 * Submit the form, when edit is finished
	 */
	function sumbit() {
		// If page doesn't have a code, show an error message and close the dialog
		if (lod_.isNil(page.code)) {
			dispatch(
				display({
					message: "Impossible de modifier cette page, aucun code trouvé.",
					type: "error"
				})
			);
			close();
			return;
		}

		// Get page permission
		let pagePermission = createPagePermission(page, rolesList);

		/**
		 * Create the new permissions for the selected roles in
		 * the "permissions" collection
		 */
		dispatch(
			ProfileActions.updateRolesByPagePermission(
				profile.assistantID,
				pagePermission,
				rolesList,
				res => {}
			)
		);

		/**
		 * Refresh the permissions of the user
		 * in the store
		 */
		dispatch(
			ProfileActions.getCustomPermissions(profile.assistantID, profile.role, res => {
				// Update store with the new permissions
				dispatch(updatePermissions(res.permissions));
			})
		);

		// Update new page object
		if (!rolesList || lod_.isEmpty(rolesList)) {
			pagePermission = [];
		} else {
			pagePermission = [pagePermission];
		}

		/**
		 * Update the "page" document permissions
		 * in the settings collection
		 */
		dispatch(
			SettingsActions.editSettingV2(
				page.code,
				{
					permissions: pagePermission
				},
				() => {
					dispatch(
						display({
							message: i18n.t("SETTINGS.PAGES.SUCCESS.edit"),
							type: "success"
						})
					);
					refreshList();
					dispatch(ProfileActions.updateMenu(profile.assistantID));
					close(true);
				}
			)
		);
	}

	/**
	 * Get the permissions of the page (if exists)
	 * and load all the roles that have this permission
	 */
	function loadRolesByPagePermission(page) {
		if (!page) return;

		let pagePermissions = page.permissions || [];

		let promises = [];
		let tempRolesList = [];

		for (let perm of pagePermissions) {
			promises.push(
				new Promise((resolve, reject) => {
					dispatch(
						ProfileActions.getRolesByPagePermission(profile.assistantID, perm, res => {
							let roles = res.roles.map(role => role.role);
							tempRolesList = [...tempRolesList, ...roles];
							resolve();
						})
					);
				})
			);
		}

		Promise.all(promises).then(() => {
			setRolesList(tempRolesList);
		});
	}
	/**
	 * Update the roles list when user select / deselect a role
	 */
	function updateRolesList(newRole) {
		if (rolesList.includes(newRole)) {
			setRolesList(rolesList.filter(role => role !== newRole));
		} else {
			setRolesList([...rolesList, newRole]);
		}
	}
	/**
	 * Load default roles list (from KM)
	 */
	function loadRoles() {
		dispatch(
			SettingsActions.getRoles(res => {
				// Sort by type
				res.roles.sort((a, b) => {
					if (a.type < b.type) return -1;
					if (a.type > b.type) return 1;
					return 0;
				});
				setDefaultRolesList(res.roles);
			})
		);
	}
	/**
	 * Load page attributes on start
	 */
	useEffect(() => {
		loadRolesByPagePermission(page);
	}, [page]);

	/**
	 * Load roles list on start
	 */
	useEffect(() => {
		loadRoles();
	}, []);

	return (
		<Dialog fullWidth maxWidth="lg" open={open} onClose={() => close()}>
			<DialogTitle>{i18n.t("SETTINGS.PAGES.visibleBy")}</DialogTitle>
			<DialogContent>
				{defaultRolesList &&
					defaultRolesList.map((perm, index) => {
						return (
							<RolesBox
								key={index}
								name={perm.name}
								code={perm.code}
								rolesList={rolesList}
								onChange={perm => {
									updateRolesList(perm);
								}}
							/>
						);
					})}
			</DialogContent>
			<DialogActions>
				<MDButton variant="outlined" color="info" onClick={() => close()}>
					{i18n.t("SETTINGS.cancel")}
				</MDButton>
				<MDButton variant="contained" color="info" onClick={sumbit}>
					{i18n.t("SETTINGS.edit")}
				</MDButton>
			</DialogActions>
		</Dialog>
	);
}
